/** Textos da lista de serviços (secção Serviços). */

export const LISTA_SERVICOS_REGISTER_SERVICE_BUTTON = 'Registrar serviço';
